import React from 'react';

export const AboutSection = () => {
  return (
    <section id="about" className="py-24 max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-[10px] font-bold tracking-[0.3em] text-amber-600 uppercase mb-4 font-sans">
            Admin Dashboard
          </p>
          <h2 className="text-4xl font-serif font-medium text-slate-900 leading-tight mb-6">
            Everything you need<br />to manage operations
          </h2>
          <p className="text-slate-500 leading-relaxed mb-5 text-[15px] font-light">
            Our admin portal provides comprehensive tools for project management, team coordination, lead tracking, and inventory control. Streamline your workflow with real-time data and automated processes.
          </p>
          <p className="text-slate-500 leading-relaxed text-[15px] font-light">
            Access detailed analytics, manage documents, and oversee site visits—all from one centralized platform designed for efficiency and clarity.
          </p>
          <div className="mt-8 flex items-center gap-6">
            <div className="h-px flex-1 bg-slate-200" />
            <span className="text-[10px] font-bold tracking-widest text-slate-400 uppercase font-sans">SD Admin Portal</span>
            <div className="h-px flex-1 bg-slate-200" />
          </div>
        </div>
        <div className="relative">
          <img src={require('../../../assets/Images/5.jpg')} alt="Admin Dashboard" className="w-full h-[480px] object-cover rounded-2xl shadow-2xl" />
          <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-5 shadow-xl border border-slate-100">
            <div className="text-2xl font-serif font-bold text-slate-900">24/7</div>
            <div className="text-[10px] font-bold tracking-widest text-slate-400 uppercase mt-0.5 font-sans">Access Available</div>
          </div>
        </div>
      </div>
    </section>
  );
};




